import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Container, Dimmer, Grid, Header, Loader } from 'semantic-ui-react';
import { Push, push } from 'connected-react-router';
import { IProject } from '@relab/alstom-ptw-shared';

import { HeaderComponent } from '../components/HeaderComponent';
import { NavBar } from '../components/NavBar';
import { ProjectDetailComponent } from '../components/project/ProjectDetailComponent';
import { ProjectWarningsComponent } from '../components/project/ProjectWarningsComponent';
import { projectAction } from '../redux/actions';
import { appState } from '../redux/selectors';
import { RootState } from '../redux/types';
import { TranslationComponent } from '../components/TranslationComponent';

interface ProjectDetailSceneProps extends Component {
  push: Push;
  projectId: string;
  projectAction: typeof projectAction;
  project: IProject;
}

class PProjectDetailScene extends Component<ProjectDetailSceneProps> {
  componentDidMount() {
    const { projectId } = this.props;
    this.props.projectAction(projectId);
  }

  render() {
    const { push, project } = this.props;

    if (!project) {
      return (
        <Dimmer active inverted>
          <Loader inverted>
            <TranslationComponent stringKey={'Loading'} />
          </Loader>
        </Dimmer>
      );
    }

    return (
      <React.Fragment>
        <HeaderComponent />
        <NavBar />
        <Container fluid>
          <Grid>
            <Grid.Row>
              <Grid.Column floated="left" textAlign="center" width={2}>
                <Button primary onClick={() => push('../')}>
                  <TranslationComponent stringKey={'Back'} />
                </Button>
              </Grid.Column>
              <Grid.Column textAlign="center" width={2}>
                <Header>{project.name}</Header>
              </Grid.Column>
              <Grid.Column floated="right" width={2} />
            </Grid.Row>
          </Grid>
          <ProjectWarningsComponent project={project} />
          <ProjectDetailComponent project={project} />
        </Container>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state: RootState, ownProps: any) => ({
  projectId: ownProps.match.params.projectId,
  project: appState(state).project,
});

export const ProjectDetailScene = connect(mapStateToProps, { push, projectAction })(PProjectDetailScene);
